import { MyStockView } from "@/components/stock-tracking/MyStockView";
import { PageCard } from "@/components/layout/PageCard";
import { createRoute } from "@tanstack/react-router";

import { layoutRoute } from "../$layoutRoute";

/**
 * The salon's opt-in stock tracking ("My Stock", #71). A list of tracked
 * variants with inline reorder-level / on-hand editing and a due-to-reorder
 * flag, plus a bulk "Track from your orders" seed for the cold start. A main-sidebar
 * destination, so it hangs off `layoutRoute` rather than the account shell; the
 * URL stays `/account/stock` so existing links keep working.
 */
export const accountStockRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "account/stock",
  component: AccountStockPage
});

function AccountStockPage() {
  return (
    <PageCard>
      <MyStockView />
    </PageCard>
  );
}
